import { repository } from 'src/jtech/jtech-repository'

export const ServiceRequestRepository = {

  INTERFACE_NAMES: {
    LOAD_INVOICE_SETTLEMENT: 'invoiceSettlement.pesquisarInvoiceSettlementConsumerUnit',
    BILLING_EXEMPTION: 'invoiceSettlementBillingExemption.createdBillingExemption',
    PROCESS_INVOICES: 'invoiceSettlementBillingExemption.processInvoices',
    DETAIL_INVOICE_SETTLEMENT: 'invoiceSettlement.detalharInvoiceSettlementById',
    BILLING_CANCELLATION: 'invoiceSettlementCancellation.createBillingCancellation',
    ECONOMIES: 'invoiceSettlementCancellation.pesquisarEconomiasConsumerUnit',
    SEARCH_BY_INTERVAL: 'invoiceSettlementCancellation.pesquisarInvoicesPorData'
  },

  async loadInvoiceSettlementConsumerUnit (consumerUnit) {
    try {
      return await repository.resolve(
        this.INTERFACE_NAMES.BILLING_CANCELLATION,
        { id: consumerUnit }
      )
    } catch (error) {
      console.error('Erro ao carregar economias da Unidade Consumidora:', error)
      throw error
    }
  },

  async loadDatatable () {
    try {
      return await repository.resolveDatatable(
        this.INTERFACE_NAMES.LOAD_INVOICE_SETTLEMENT
      )
    } catch (error) {
      console.error('Erro ao carregar datatable:', error)
      throw error
    }
  },

  async loadDatatableModel (params) {
    try {
      const { registros: records } = await repository.resolveDatatableModel(
        this.INTERFACE_NAMES.LOAD_INVOICE_SETTLEMENT,
        { ...params }
      )
      return records
    } catch (error) {
      console.error('Erro ao carregar modelo do datatable:', error)
      throw error
    }
  },

  // Métodos para isenção de cobrança
  async createdBillingExemption (consumerUnit) {
    try {
      return await repository.resolve(
        this.INTERFACE_NAMES.BILLING_EXEMPTION,
        { consumerUnit }
      )
    } catch (error) {
      console.error('Erro ao criar isenção de cobrança:', error)
      throw error
    }
  },

  async createBillingCancellation (consumerUnit) {
    try {
      return await repository.resolve(
        this.INTERFACE_NAMES.BILLING_CANCELLATION,
        { id: consumerUnit }
      )
    } catch (error) {
      console.error('Erro ao criar cancelamento de cobrança:', error)
      throw error
    }
  },

  async applyExemption (params) {
    try {
      return await repository.resolveLogic(
        this.INTERFACE_NAMES.BILLING_EXEMPTION,
        { ...params }
      )
    } catch (error) {
      console.error('Erro ao aplicar isenção:', error)
      throw error
    }
  },

  async applyCancellation (params) {
    try {
      return await repository.create(
        this.INTERFACE_NAMES.BILLING_CANCELLATION,
        { ...params }
      )
    } catch (error) {
      console.error('Erro ao aplicar cancelamento:', error)
      throw error
    }
  },

  async processInvoices (params) {
    return await repository.resolveLogic(
      this.INTERFACE_NAMES.PROCESS_INVOICES,
      { ...params }
    )
  },

  async detail (id) {
    try {
      return await repository.resolve(
        this.INTERFACE_NAMES.DETAIL_INVOICE_SETTLEMENT,
        { id: id }
      )
    } catch (error) {
      console.error('Erro ao buscar detalhes:', error)
      throw error
    }
  },

  async loadInvoicesByDate (params) {
    return await repository.resolveLogic(
      this.INTERFACE_NAMES.SEARCH_BY_INTERVAL,
      { ...params }
    )
  }
}
